import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { PrizeQueryFilter } from '../prize-query-filter';
import { PrizeList } from '../prize-list';
import { PrizeService } from '../prize.service';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { Prize } from '../prize';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-prize-list',
    templateUrl: './prize-list.component.html',
    styleUrls: ['./prize-list.component.scss'],
    standalone: false
})
export class PrizeListComponent extends BaseComponent implements OnInit, AfterViewInit {
  public prizes: PrizeList[] = [];
  public filter: PrizeQueryFilter = new PrizeQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();

  constructor(public sessionService: SessionService,
    private prizeService: PrizeService,
    public dialog: MatDialog,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.filter.pageSize = 15;
    this.displayedColumns = ['name', 'description', 'value', 'expenseCost', 'actions'];
   }

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.setSearchKey(this.selectedIteration);
      this.getPrizes();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.subscribe(result => {
      this.selectedIteration = result;
      this.getPrizes();
    })
  }

  getPrizes(){
    this.isLoading = true;
    this.filter.outingIterationId = this.selectedIteration.id;
    this.prizeService.getAllByOutingIteration(this.filter).subscribe(result => {
      this.prizes = result.results;
      this.filter.totalCount = result.totalCount;
      this.updateFilterEvent.emit(result.results);
      this.isLoading = false;
    },err => {
      this.isLoading = false;
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getPrizes();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  delete(prize: Prize){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Prize';
    dialogRef.componentInstance.body = `Are you sure you want to remove <strong>"${prize.name}"</strong>`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      this.isLoading = true;
      if (response === 'Yes') {
        let model = {id: prize.id, lastEditedBy: this.getUserIdFromSession()};
        this.prizeService.delete(prize.id, model).subscribe(() => {
          this.getPrizes();
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
        });
      }
      this.isLoading = false;
    });
  }

  canEditOrDelete(): boolean{
    return new Date() <= new Date(this.selectedIteration.startDate);;
  }
}
